/**
 * 应用主入口
 */
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import GameManagement from './pages/GameManagement';
import Profile from './pages/Profile';
import DeviceDetail from './pages/DeviceDetail';
import BindDevice from './pages/BindDevice';
import UserManagement from './pages/UserManagement';
import PrivateRoute from './components/PrivateRoute';

// 需要登录的路由配置
const privateRoutes = [
  { path: '/games', element: <GameManagement /> },
  { path: '/profile', element: <Profile /> },
  { path: '/device/:deviceId/:mac', element: <DeviceDetail /> },
  { path: '/bind-device', element: <BindDevice /> },
  { path: '/admin/users', element: <UserManagement /> },
];

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        {privateRoutes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={<PrivateRoute>{element}</PrivateRoute>}
          />
        ))}
        
        <Route path="/" element={<Navigate to="/games" replace />} />
        <Route path="*" element={<Navigate to="/games" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
